//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { Grid, makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../../common/definitionHelper';
import { LayoutContext } from '../../../common/contexts';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../../../common/elemental/AfitdPageHead';
import { PAGE_TITLE_MESSAGE } from '../../../common/constants';
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            // overflow: 'hidden',
        },

        aboutUsProfileContainer: {
            padding: 10,
            background: 'white',
            borderRadius: 10,
        },
        aboutUsContent: {
            padding: '0px 20px',
            overflowY: 'scroll',
            overflowX: 'hidden',
            height: 530,
            [theme.breakpoints.down('md')]: { height: '700px' },
            [theme.breakpoints.down('sm')]: { height: '570px' },
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
        paragraphText: { fontSize: 18, fontWeight: 400 },
        sidebarHeading: {
            fontWeight: 'bold',
            fontSize: 18,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 15,
            cursor: 'pointer',
            borderLeft: '4px solid rgba(255, 255, 255, 1)',
            '&:hover': { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' },
        },
        TitleText: { fontSize: 20, textAlign: 'center' },
        TitleTextAGREEMENT: { fontSize: 20 },
        headerText: { fontSize: 20, fontWeight: 'bold' },
        updateText: { fontStyle: 'italic', color: '#434343', fontSize: 18 },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        aboutUsProfileContainer: { item: true, xl: 7, lg: 7, md: 11, sm: 11, xs: 11 },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const TheMessage = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    const layoutContext = useContext(LayoutContext);
    const { scrollToPageTop } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    const [OpenDropdown, setOpenDropdown] = useState(false);
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, setOpenDropdown, OpenDropdown });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.aboutUsProfileContainer}>
            <AfitdPageHead title={PAGE_TITLE_MESSAGE} />
            <div {...defns.aboutUsContent}>
                <div>
                    <h3>The Message</h3>
                </div>
                <div>
                    <p {...defns.paragraphText}>
                        If you are graduating/coming out of high school, college, graduate school, the military, or trade school of any kind, where do you go to find your first
                        job? Hold on… were you going to say one of those sites where you upload your resume and then hope for the best? How do you stand out on those sites? Based
                        on a digital resume, how will an employer ever know what you really bring to the table amongst the ocean of applicants?
                    </p>
                    <p {...defns.paragraphText}>
                        The reality is that you (the new job seeker) possess the next wave of brilliance that will drive industry for the foreseeable future. Unfortunately, you
                        (the new job seeker) comprise the most vulnerable population of the job market. The tools, products, and resources to help you (the new job seeker) succeed
                        are too limited. Historically, very little attention has been paid to this important demographic and all of that changes TODAY!
                    </p>
                    <p {...defns.paragraphText}>
                        A Foot in the Door was developed as a platform exclusively to help job seekers with 0-5 years of work experience find employment that maximizes their
                        potential, talents, and gifts. Helping you (the new job seeker) get your ‘foot in the door’ of your dream career is what we are ALL about, this is our lane.
                    </p>
                </div>
            </div>
        </Grid>
    );
};

export default TheMessage;
